import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Panel} from "primereact/panel";
import {ProgressBar} from "primereact/progressbar";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {Card} from "primereact/card";
import {Checkbox} from "primereact/checkbox";
import {OverlayPanel} from 'primereact/overlaypanel';
import {InputNumber} from "primereact/inputnumber";
import axios from "axios";
import Cookies from "js-cookie";
import currencyFormatter from "currency-formatter";
import {Tooltip} from "primereact/tooltip";
import {Message} from "primereact/message";
import HelpComponent from "../HelpComponent";
import {closeMercureSubscription, openMercureSubscription} from "../../util/mercure";

const _FM_FolioDndComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [folios, setFolios] = useState([]);
  const [ifa, setIfa] = useState({});
  const [ifas, setIfas] = useState([]);
  const [receipt, setReceipt] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingPrices, setLoadingPrices] = useState(false);
  const [loadingFolios, setLoadingFolios] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [dialogIfa, setDialogIfa] = useState([]);
  const op = useRef(null);
  const [note, setNote] = useState('');
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedItems, setDraggedItems] = useState([]);
  const [draggedItemFolio, setDraggedItemFolio] = useState(null);
  const [draggedFolio, setDraggedFolio] = useState(null);
  const [sourceFolioId, setSourceFolioId] = useState(null);
  const [targetFolioId, setTargetFolioId] = useState(null);
  const formatQuantity = (quantity) => {
    const parsedQuantity = Number(quantity);
    return Number.isInteger(parsedQuantity) ? String(parsedQuantity) : parsedQuantity.toFixed(2);
  };
  const handleDragStart = (e, folioId, item) => {
    setDraggedItem(item);
    setSourceFolioId(folioId);
    e.dataTransfer.effectAllowed = "move";
    document.querySelectorAll('.dropzone').forEach((div) => {
      div.classList.add('active');
    });
  };
  const handleDragEnd = (event, item) => {
    document.querySelectorAll('.dropzone').forEach((div) => {
      div.classList.remove('active');
    });
  };
  const handleContainerDragStart = (e, folioId) => {
    setDraggedFolio(folioId);
    e.dataTransfer.effectAllowed = "move";
  };
  const handleDrop = (e, targetFolioId) => {
    setTargetFolioId(targetFolioId);
    let _targetFolio = folios.filter(folio => folio.id === targetFolioId)[0];
    if (_targetFolio.folio.invoiced === true) {
      window.App.customToastShow('warn', t('warning'), t('folio_invoiced'));
      return
    }
    if (sourceFolioId !== targetFolioId && !draggedFolio && !draggedItems[0]) { //one item drop
      if (draggedItem?.service?.available_for === 'reservation' && _targetFolio?.folio?.customer !== null) {
        window.App.customToastShow('warn', t('warning'), t('folio_item_not_available_for_customer'));
      } else if (draggedItem?.service?.available_for === 'customer' && _targetFolio?.folio?.reservation_group !== null) {
        window.App.customToastShow('warn', t('warning'), t('folio_item_not_available_for_reservation'));
      } else {
        setDialog(true)
      }
    }
    if (!draggedFolio && draggedItems[0]) { // more items drop
      if (draggedItems.includes(draggedItem.id)) {
        setLoading(true)
        let _data = {
          folio_items: draggedItems
        }
        apiCall('post', 'folio/overview/' + sourceFolioId + '/' + targetFolioId + '/move-selected', _data)
          .then(response => {
            setLoadingFolios([targetFolioId, sourceFolioId])
            setLoadingPrices(true)
            setDraggedItems([]);
            setDraggedItemFolio(null)
            setSourceFolioId(null);
            setTargetFolioId(null);
            window.App.setState({
              rerenderFolioDnd: Math.random(),
              rerenderFolioList: Math.random(),
            })
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      } else { //more items selected but not seleted has been dropped
        setDialog(true)
      }
    }
    if (draggedFolio) { //folio drop
      apiCall('get', 'folio/overview/' + draggedFolio + '/' + targetFolioId)
        .then(response => {
          setLoadingFolios([targetFolioId, sourceFolioId])
          setLoadingPrices(true)
          setDraggedFolio(null);
          setSourceFolioId(null);
          setTargetFolioId(null);
          window.App.setState({
            rerenderFolioDnd: Math.random(),
            rerenderFolioList: Math.random(),
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    e.preventDefault();
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  const priceReload = (droppedFolioID) => {
    setLoadingPrices(true)
    const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
      + Cookies.get("instanceId") + "/folio/" + droppedFolioID;
    const eventSource = openMercureSubscription({
      topics: [topic],
    });
    if (!eventSource) {
      setLoadingPrices(false)
      return () => {};
    }

    console.log('feliratkozás történt: ' + topic)
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('push notification arrived:');
      console.log(data)
      window.App.setState({rerenderFolioDnd: Math.random()})
      setLoadingPrices(false)
    }
    return () => {
      closeMercureSubscription(eventSource);
      console.log('leiratkozás történt: ' + topic)
    };
  }

  useEffect(() => {
    if (loadingPrices && loadingFolios[0]) {
      const cleanup = priceReload(loadingFolios[0]);
      return () => {
        cleanup();
      };
    }
  }, [loadingPrices]);

  useEffect(() => {
    if (window.App.urlVars().folioIds) {
      let _folioIds = window.App.urlVars().folioIds.split(',')
      if (_folioIds && _folioIds[0]) {
        setLoading(true)
        let _folios = []
        _folioIds.map((folioId, index) => {
          apiCall('get', "folio/" + folioId)
            .then(response => {
              let _folioData = response.data.data
              apiCall('get', 'folio-item?search[folio][operator]=%3D&search[folio][value]=' + response.data.data.id)
                .then(response => {
                  _folios.push({
                    id: _folioData.id,
                    folio: _folioData,
                    items: response.data.data.items,
                  })
                  if (index === _folioIds.length - 1) {
                    setTimeout(() => {
                      _folios.sort((a, b) => a.id - b.id);
                      setFolios(_folios)
                      setLoading(false)
                    }, 500)
                  }
                })
                .catch(error => {
                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                })
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
        })
      }
    }
  }, [window.App.state.rerenderFolioDnd, window.App.urlVars().folioIds])

  useEffect(() => {
    if (window.App.urlVars().invoiceId) {
      apiCall('get', 'invoice/' + window.App.urlVars().invoiceId)
        .then(response => {
          setReceipt(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.urlVars().invoiceId])

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: 'absolute', top: 0, zIndex: 9}}></ProgressBar>
      }
      <div className={"p-grid p-my-3"}>
        <div className={"p-col-12 p-lg-6 p-py-0 p-col-align-center"}>
          <h2 className={"p-my-0"}>
            {t('folios_manage')}
          </h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-py-0 p-text-right p-col-align-center"}>
          {!window.App.urlVars().invoiceId &&
            <Button type="button" label={t('new_receipt_from_items')} icon={"pi pi-plus"}
                    disabled={!draggedItems[0]}
                    onClick={() => {
                      let _params = '?'
                      Object.entries(window.App.urlVars()).map(([key, value]) => {
                        _params += key + '=' + value + '&'
                      })
                      _params += 'create=invoice&folioItemIds=' + draggedItems.toString()
                      if (window.location.hash.toString().includes('#/folio')) {
                        navigate('/folio/manage' + _params)
                      }
                      if (window.location.hash.toString().includes('#/reservation')) {
                        navigate('/reservation/' + action + '/' + id + "/" + _params)
                      }
                      if (window.location.hash.toString().includes('#/calendar')) {
                        navigate('/calendar/' + action + '/' + id + "/" + _params)
                      }
                      if (window.location.hash.toString().includes('#/customer')) {
                        navigate('/customer/' + action + '/' + id + "/" + _params)
                      }
                      if (window.location.hash.toString().includes('#/control-panel')) {
                        navigate('/control-panel' + _params)
                      }
                    }}
                    className="p-button-success p-ml-2"/>
          }
          {/*{!window.App.urlVars().invoiceId &&*/}
          {/*  <Button type="button" label={t('new_receipt')} icon={"pi pi-plus"}*/}
          {/*          onClick={() => {*/}
          {/*            let _params = '?'*/}
          {/*            Object.entries(urlVars).map(([key, value]) => {*/}
          {/*              _params += key + '=' + value + '&'*/}
          {/*            })*/}
          {/*            _params += 'create=invoice'*/}
          {/*            navigate('/folio/manage' + _params)*/}
          {/*          }}*/}
          {/*          className="p-button-success p-ml-2"/>*/}
          {/*}*/}
          {window.location.hash.toString().includes('#/folio') &&
          <Button type="button" label={t('new_folio')} icon={"pi pi-plus"}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/folio')) {
                      navigate('/folio/create?accommodationId=' + folios[0]?.folio?.accommodation?.id + '&folioIds=' + window.App.urlVars().folioIds)
                    }
                    // if (window.location.hash.toString().includes('#/control-panel')) {
                    //   navigate('/control-panel?create=folio' + '&folioIds=' + window.App.urlVars().folioIds)
                    // }
                    // if (window.location.hash.toString().includes('#/reservation')) {
                    //   navigate('/reservation/' + action + '/' + id + '?create=folio' + '&folioIds=' + window.App.urlVars().folioIds)
                    // }
                  }}
                  className="p-button-success p-ml-2"/>
        }
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/folio')) {
                      navigate('/folio')
                    }
                    if (window.location.hash.toString().includes('#/control-panel')) {
                      navigate('/control-panel')
                    }
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <Message severity="info" className={"p-d-block p-m-3 p-border-secondary"} text={t('folio_dnd_help')}/>
      {folios && folios[0] &&
        <Panel className={"p-mt-0"}>
          <div className="p-grid folio-manage"
               style={{overflowX: 'auto !important', display: 'flex', flexWrap: 'nowrap'}}>
            {folios.map((folio) => {
              return (
                <div
                  key={folio.id}
                  onDragOver={handleDragOver} // Drag Over esemény
                  onDrop={(e) => handleDrop(e, folio.id)} // Drop esemény
                  style={{minWidth: '300px', maxWidth: '33%'}}
                  className="p-col"
                >
                  {/* Folio információk */}
                  <div className="column-header p-mb-2" style={{borderRadius: "4px", cursor: 'move'}}
                       key={folio.id}
                       draggable
                       onDragEnd={(e) => handleDragEnd(e, folio.id, folio)}
                       onDragStart={(e) => handleContainerDragStart(e, folio.id, folio)} // Drag Start esemény
                  >
                    <h4 className={"p-p-0 p-m-0"}>
                      <span className={"tooltip-" + folio?.folio?.id}>
                        {folio?.folio?.name}
                      </span>
                      <Tooltip target={".tooltip-" + folio?.folio?.id}>
                        {t('folio')}: {folio?.folio?.id}
                      </Tooltip>
                    </h4>
                    {folio?.folio?.customer?.id &&
                      <span className={"p-d-block"} style={{position: "relative", top: "-3px"}}>
                        {/*<i className={"pi pi-window-maximize"}*/}
                        {/*   style={{position: "relative", bottom: "-1px"}}*/}
                        {/*   onClick={(e) => {*/}
                        {/*     navigate('/customer/read/' + folio?.folio?.customer?.id)*/}
                        {/*   }}*/}
                        {/*></i>*/}
                        {/*&nbsp;*/}
                        {folio?.folio?.customer?.lastname} {folio?.folio?.customer?.firstname}
                      </span>
                    }
                    {/*{folio.folio?.reservation_group?.id &&*/}
                    {/*  <span className={"p-d-block"} style={{position: "relative", top: "-3px"}}>*/}
                    {/*    <i className={"pi pi-window-maximize"}*/}
                    {/*       style={{position: "relative", bottom: "-1px"}}*/}
                    {/*       onClick={(e) => {*/}
                    {/*         navigate('/control-panel/reservation-group/read/' + folio.folio?.reservation_group?.id)*/}
                    {/*       }}*/}
                    {/*    ></i>*/}
                    {/*    &nbsp;*/}
                    {/*    {folio.folio?.reservation_group?.public_id.toUpperCase()}*/}
                    {/*  </span>*/}
                    {/*}*/}
                    <div className={"p-grid p-mt-1"}>
                      <div className={"p-col-7 p-py-0 p-col-align-center"}>
                        <small className={"p-d-block"}>
                          {t('net_amount')}:
                          &nbsp;
                          {loadingPrices && loadingFolios.includes(folio.folio.id) ? (
                            <i className="pi pi-spin pi-spinner"
                               style={{fontSize: '1rem', position: 'relative', bottom: '-2px'}}></i>
                          ) : (
                            <span className={""}>
                              {currencyFormatter.format(
                                folio?.folio?.net_amount, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                }
                              )} {folio?.folio?.currency}
                            </span>
                          )}
                        </small>
                        <small className={"p-d-block"}>
                          {t('gross_amount')}:
                          &nbsp;
                          {loadingPrices && loadingFolios.includes(folio.folio.id) ? (
                            <i className="pi pi-spin pi-spinner"
                               style={{fontSize: '1rem', position: 'relative', bottom: '-2px'}}></i>
                          ) : (
                            <span className={"p-text-bold"}>
                              {currencyFormatter.format(
                                folio?.folio?.gross_amount, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                }
                              )}
                              &nbsp;
                              {folio?.folio?.currency}
                          </span>
                          )}
                        </small>
                      </div>
                      <div className={"p-col-5 p-py-0 p-text-right p-col-align-center"}>
                        <Button icon="pi pi-info-circle" className="p-button-sm p-button-secondary p-ml-2"
                                tooltip="Számlázási adatok"
                                tooltipOptions={{position: 'left'}}
                                disabled={!folio?.folio?.billing_data?.name_or_company_name}
                                onClick={() => {
                                  document.getElementById('billing-data-' + folio.id).classList.toggle("p-d-none");
                                }}/>
                        {window.location.hash.toString().includes('#/folio') &&
                          <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-ml-2"
                                  tooltip={t('show')}
                                  tooltipOptions={{position: 'left'}}
                                  onClick={() => {
                                    if (window.location.hash.toString().includes('#/folio')) {
                                      navigate('/folio/read/' + folio?.folio?.id)
                                    }
                                  }}/>
                        }
                        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-ml-2"
                                tooltip={t('edit')}
                                tooltipOptions={{position: 'left'}}
                                disabled={folio?.folio?.invoiced}
                                onClick={() => {
                                  let _params = '?'
                                  Object.entries(window.App.urlVars()).map(([key, value]) => {
                                    _params += key + '=' + value + '&'
                                  })
                                  _params += 'update=folio&folioId=' + folio?.folio?.id
                                  if (window.location.hash.toString().includes('#/folio')) {
                                    navigate('/folio/update/' + folio?.folio?.id)
                                  }
                                  if (window.location.hash.toString().includes('#/control-panel')) {
                                    navigate('/control-panel?update=folio&folioId=' + folio?.folio?.id)
                                  }
                                  if (window.location.hash.toString().includes('#/reservation')) {
                                    navigate('/reservation/' + action + '/' + id + '?update=folio&folioId=' + folio?.folio?.id)
                                  }
                                  if (window.location.hash.toString().includes('#/calendar')) {
                                    navigate('/calendar/' + action + '/' + id + _params)
                                  }
                                  if (window.location.hash.toString().includes('#/customer')) {
                                    navigate('/customer/' + action + '/' + id + _params)
                                  }
                                }}/>
                      </div>
                    </div>
                    <div className={"p-d-none p-mt-2"} id={'billing-data-' + folio.id}>
                      <hr className={""}/>
                      <strong className={"p-d-block"}>{folio?.folio?.billing_data?.name_or_company_name}</strong>
                      <small className={"p-d-block"}>{folio?.folio?.billing_data?.vat_number}</small>
                      <small
                        className={"p-d-block"}>
                        {folio?.folio?.billing_data?.country?.toUpperCase()} {folio?.folio?.billing_data?.zip_code}, {folio?.folio?.billing_data?.street_and_number}
                      </small>
                    </div>
                  </div>
                  {/* Folio itemek (szolgáltatások) */}
                  {folio.items.length > 0 ? (
                    folio.items.map((item) => {
                      let _bgColor = '#fff'
                      if (item.on_invoice === true) {
                        _bgColor = '#e6f8f3'
                      }
                      let _cursor = 'move'
                      if (item?.folio?.invoiced === true || item?.on_invoice === true) {
                        _cursor = 'not-allowed'
                      }
                      return (
                        <Card
                          style={{cursor: _cursor, position: 'relative', backgroundColor: _bgColor}}
                          className="grid-cell p-my-3 p-pt-2"
                          key={item.id}
                          draggable={item?.folio?.invoiced != true || item?.on_invoice != true}
                          onDragStart={(e) => handleDragStart(e, folio.id, item)} // Drag Start esemény
                          onDragEnd={(e) => handleDragEnd(e, folio.id, folio)}
                        >
                          {(item?.folio?.invoiced != true || item?.on_invoice != true) &&
                            <span style={{
                              position: 'absolute',
                              right: '0',
                              bottom: '0',
                              backgroundColor: '#ebedf2',
                              borderBottomRightRadius: '3px',
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              lineHeight: 1
                            }}>
                              <i className={"pi pi-th-large"} style={{color: '#495057'}}></i>
                            </span>
                          }
                          <div className="p-grid">
                            <div className="p-col-6 p-py-0">
                            <span className="p-d-block p-text-bold">
                              <Checkbox value={item.id}
                                        disabled={(draggedItemFolio && draggedItemFolio !== item?.folio?.id) || (item?.folio?.invoiced === true || item?.on_invoice === true)}
                                        style={{position: 'relative', top: '-1px'}}
                                        onChange={(e) => {
                                          let _draggedItems = [...draggedItems];
                                          if (e.checked) {
                                            setDraggedItemFolio(item?.folio?.id)
                                            _draggedItems.push(e.value);
                                          } else {
                                            _draggedItems.splice(_draggedItems.indexOf(e.value), 1);
                                            if (_draggedItems.toString().length < 1) {
                                              setDraggedItemFolio(null)
                                            }
                                          }
                                          setDraggedItems(_draggedItems);
                                        }}
                                        checked={draggedItems.includes(item.id)}
                              ></Checkbox>
                              &nbsp;
                              &nbsp;
                              {item?.label || item?.service?.name}
                            </span>
                              <div>
                                {formatQuantity(item.quantity)} {item?.service?.unit || item.unit}
                              </div>
                            </div>
                            <div className="p-col-6 p-py-0 p-text-bold p-text-right">
                              <label htmlFor="tot_price" className={"p-d-block"}>
                                {item.current_invoice_id &&
                                  <>
                                    <i className={"pi pi-window-maximize"}
                                       onClick={(e) => op.current.toggle(e)}
                                    ></i>
                                    &nbsp;
                                    <OverlayPanel ref={op} style={{maxWidth: '250px'}}>
                                      <div className={"p-grid p-p-0 p-m-0"}>
                                        <div className={"p-col-8 p-col-align-center p-p-0 p-m-0"}
                                             onClick={(e) => {
                                               navigate('/receipt/update/' + item.current_invoice_id)
                                             }}
                                        >
                                          <span style={{textDecoration: 'underline', cursor: 'pointer'}}>
                                            {item.current_invoice_third_party_id || t('receipt_show')}
                                          </span>
                                        </div>
                                        <div className={"p-col p-text-right p-col-align-center p-p-0 p-m-0"}>
                                          <Button icon="pi pi-download"
                                                  className="p-button-sm p-button-secondary"
                                                  tooltip={t('download')}
                                                  disabled={!item.pdf_url}
                                                  loading={loading}
                                                  tooltipOptions={{position: 'left'}}
                                                  onClick={() => {
                                                    window.open(item.pdf_url, '_blank', 'noopener,noreferrer');
                                                  }}
                                          />
                                        </div>
                                      </div>
                                    </OverlayPanel>
                                  </>
                                }
                                {t('tot_price')}
                                &nbsp;
                                <i className={"pi pi-info-circle"} style={{cursor: 'pointer'}} onClick={() => {
                                  document.getElementById('price-' + item.id).classList.toggle("p-d-none");
                                }}></i>
                              </label>
                              {currencyFormatter.format(
                                item.gross_amount, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                }
                              )}
                              &nbsp; {item?.folio?.currency}
                            </div>
                          </div>
                          <div className={"prices p-d-none"} id={"price-" + item.id}>
                            <hr className={"p-mb-3"}/>
                            <div className="p-grid">
                              <div className="p-col p-py-0">
                                <small>
                                  <label htmlFor="net_amount" className={"p-d-block"}>{t('net_amount')}</label>
                                  {currencyFormatter.format(
                                    item?.net_amount, {
                                      precision: t('currency_precision'),
                                      symbol: t('currency_symbol'),
                                      decimal: t('currency_decimal'),
                                      thousand: t('currency_thousand'),
                                    }
                                  )}
                                  &nbsp; {item?.folio?.currency}
                                </small>
                              </div>
                              <div className="p-col p-py-0">
                                <small>
                                  <label htmlFor="vat_percent" className={"p-d-block"}>{t('vat_percent')}</label>
                                  {item.vat_percent} %
                                </small>
                              </div>
                              <div className="p-col p-py-0 p-text-bold p-text-right">
                                <small>
                                  <label htmlFor="gross_amount" className={"p-d-block"}>{t('gross_amount')}</label>
                                  {currencyFormatter.format(
                                    item?.gross_amount, {
                                      precision: t('currency_precision'),
                                      symbol: t('currency_symbol'),
                                      decimal: t('currency_decimal'),
                                      thousand: t('currency_thousand'),
                                    }
                                  )}
                                  &nbsp; {item?.folio?.currency}
                                </small>
                              </div>
                            </div>
                          </div>
                          {item.note &&
                            <>
                              <hr className={"p-mb-1"}/>
                              <small>{item.note}</small>
                            </>
                          }
                        </Card>
                      )
                    })
                  ) : (
                    <div className="grid-empty">

                    </div>
                  )}
                  <div className={"dropzone p-mb-3"} style={{border: '2px dashed #e6e9ec', height: '68px', borderRadius: '4px'}}>

                  </div>
                  {ifas && ifas[0] &&
                    <>
                      {ifas.map((item, index) => {
                        if (item?.folio?.id !== folio.id) return;
                        return (
                          <Card
                            id={'folio-item' + index}
                            style={{border: '1px dashed #c6c6c6', boxShadow: 'none'}}
                            className="grid-cell p-my-3">
                            <div className="p-grid">
                              <div className="p-col-6 p-py-0">
                            <span className="p-d-block p-text-bold">
                              {item.label}
                            </span>
                                <div>
                                  {formatQuantity(item.quantity)} {item?.unit}
                                </div>
                              </div>
                              <div className="p-col-6 p-py-0 p-text-bold p-text-right">
                                <label htmlFor="tot_price" className={"p-d-block"}>
                                  {t('tot_price')}
                                  {/*&nbsp;*/}
                                  {/*<i className={"pi pi-info-circle"} style={{cursor: 'pointer'}} onClick={() => {*/}
                                  {/*  document.getElementById('price-' + item.id).classList.toggle("p-d-none");*/}
                                  {/*}}></i>*/}
                                </label>
                                {currencyFormatter.format(
                                  item.unit_gross_amount * item.quantity, {
                                    precision: t('currency_precision'),
                                    symbol: t('currency_symbol'),
                                    decimal: t('currency_decimal'),
                                    thousand: t('currency_thousand'),
                                  }
                                )}
                                &nbsp; {item?.folio?.currency}
                              </div>
                            </div>
                            <hr className={"p-mb-0"}/>
                            <Message severity="warn" className={"p-my-0 p-d-block p-text-center text-warning"}
                                     text={t('not_saved_yet')}
                                     style={{marginBottom: '0px', backgroundColor: 'transparent'}}/>
                            <div className={"p-grid p-pb-0"}>
                              <div className={"p-col-12 p-lg-6 p-pb-0 p-col-align-center"}>
                                <Button icon="pi pi-times" className="p-button-sm p-button-danger"
                                        tooltip={t('cancel')}
                                        label={t('cancel')}
                                        tooltipOptions={{position: 'left'}}
                                        onClick={() => {
                                          setIfas([])
                                          priceReload(folio.id)
                                        }}/>

                              </div>
                              <div className={"p-col-12 p-lg-6 p-pb-0 p-text-right p-col-align-center"}>
                                <Button icon="pi pi-arrow-right" className="p-button-sm p-button-warning"
                                        tooltip={t('ifa_approve')}
                                        label={t('ifa_approve')}
                                        tooltipOptions={{position: 'left'}}
                                        onClick={() => {
                                          setIfa(item)
                                          setDialogIfa({[index]: true})
                                        }}/>
                              </div>
                            </div>
                            <Dialog header={t('ifa_approve')} visible={dialogIfa[index]}
                                    footer={<React.Fragment><Message className={"w-100"}
                                                                     style={{background: 'transparent'}} severity="info"
                                                                     text={t("dialog_movable")}/></React.Fragment>}
                                    onHide={() => {
                                      setDialogIfa({[index]: false})
                                    }} modal={false}>
                              <Panel className={"p-mt-3"}>
                                <div className={"p-grid"}>
                                  <div className={"p-col-12 p-lg-6"}>
                                    <div className="p-field p-fluid">
                                      <label htmlFor="label">{t('label')}</label>
                                      <span className="p-d-block">
                                        <InputText id="label"
                                                   onChange={(e) => {
                                                     setIfa({
                                                       ...ifa,
                                                       label: e.target.value
                                                     })
                                                   }}
                                                   value={ifa.label}
                                        />
                                    </span>
                                    </div>
                                  </div>
                                  <div className={"p-col-12 p-lg-2"}>
                                    <div className="p-field p-fluid">
                                      <label htmlFor="unit_gross_amount">{t('gross_amount')}</label>
                                      <span className="p-d-block">
                                        <InputText id="unit_gross_amount"
                                                   keyfilter={"num"}
                                                   onChange={(e) => {
                                                     setIfa({
                                                       ...ifa,
                                                       unit_gross_amount: e.target.value
                                                     })
                                                   }}
                                                   value={ifa.unit_gross_amount}
                                        />
                                    </span>
                                    </div>
                                  </div>
                                  <div className={"p-col-12 p-lg-2"}>
                                    <div className="p-field p-fluid">
                                      <label htmlFor="quantity">{t('quantity')}</label>
                                      <span className="p-d-block">
                                        <InputText id="quantity"
                                                   keyfilter={"num"}
                                                   onChange={(e) => {
                                                     setIfa({
                                                       ...ifa,
                                                       quantity: e.target.value
                                                     })
                                                   }}
                                                   value={ifa.quantity}
                                        />
                                    </span>
                                    </div>
                                  </div>
                                  <div className={"p-col-12 p-lg-2"}>
                                    <div className="p-field p-fluid">
                                      <label htmlFor="vat_percent">{t('vat_percent')}</label>
                                      <span className="p-d-block">
                                        <InputText id="vat_percent"
                                                   keyfilter={"num"}
                                                   onChange={(e) => {
                                                     setIfa({
                                                       ...ifa,
                                                       vat_percent: e.target.value
                                                     })
                                                   }}
                                                   value={ifa.vat_percent}
                                        />
                                    </span>
                                    </div>
                                  </div>
                                </div>
                                <div className={"p-grid"}>
                                  <div className={"p-col"}>
                                  </div>
                                  <div className={"p-col p-text-right p-col-align-center"}>
                                    <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                                            label={t('save')}
                                            loading={loading}
                                            onClick={() => {
                                              setLoading(true)
                                              apiCall('post', 'folio-item', {
                                                folio: ifa.folio.id,
                                                label: ifa.label,
                                                unit_gross_amount: ifa.unit_gross_amount,
                                                quantity: ifa.quantity,
                                                vat_percent: ifa.vat_percent,
                                              })
                                                .then(response => {
                                                  document.getElementById('folio-item' + index).hidden = true;
                                                  ;
                                                  priceReload(folio.id)
                                                  setLoading(false)
                                                  setDialogIfa({[index]: false})
                                                })
                                                .catch(error => {
                                                  setLoading(false)
                                                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                })
                                            }}
                                            className="p-button-success p-ml-2"/>
                                  </div>
                                </div>
                              </Panel>
                            </Dialog>
                          </Card>
                        )
                      })}
                    </>
                  }
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                      {/*{folio.folio?.reservation_group?.id && folio?.folio?.include_tourist_tax !== true &&*/}
                      {/*  <Button icon="pi pi-users" className="p-button-sm p-button-secondary p-mr-2"*/}
                      {/*          tooltip={t('ifa_calculate')}*/}
                      {/*          loading={loading}*/}
                      {/*          label={t('ifa_calculate')}*/}
                      {/*          tooltipOptions={{position: 'left'}}*/}
                      {/*          onClick={() => {*/}
                      {/*            setIfas([])*/}
                      {/*            setLoading(true)*/}
                      {/*            apiCall('get', 'folio/calc-ifa/' + folio.id)*/}
                      {/*              .then(response => {*/}
                      {/*                setLoading(false)*/}
                      {/*                if (response.data.data && response.data.data[0]) {*/}
                      {/*                  setIfas(response.data.data)*/}
                      {/*                } else {*/}
                      {/*                  window.App.customToastShow('warn', t('warning'), t('no_ifa_calculated'));*/}
                      {/*                }*/}
                      {/*              })*/}
                      {/*              .catch(error => {*/}
                      {/*                setLoading(false)*/}
                      {/*                window.App.customToastShow('warn', t('warning'), error?.response?.data?.message)*/}
                      {/*              })*/}
                      {/*          }}/>*/}
                      {/*}*/}
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
                      {folio.items && folio.items[1] &&
                        <Button icon="pi pi-check-square" className="p-button-sm p-button-secondary p-ml-2"
                                tooltip={(() => {
                                  const selectableItemIds = folio.items
                                    .filter(item => item?.folio?.invoiced !== true && item?.on_invoice !== true)
                                    .map(item => item.id);
                                  const draggedItemIdSet = new Set(draggedItems.map(itemId => String(itemId)));
                                  const isAllSelected = selectableItemIds.length > 0
                                    && selectableItemIds.every(id => draggedItemIdSet.has(String(id)));
                                  return t(isAllSelected ? 'deselect_all' : 'select_all');
                                })()}
                                loading={loading}
                                label={(() => {
                                  const selectableItemIds = folio.items
                                    .filter(item => item?.folio?.invoiced !== true && item?.on_invoice !== true)
                                    .map(item => item.id);
                                  const draggedItemIdSet = new Set(draggedItems.map(itemId => String(itemId)));
                                  const isAllSelected = selectableItemIds.length > 0
                                    && selectableItemIds.every(id => draggedItemIdSet.has(String(id)));
                                  return t(isAllSelected ? 'deselect_all' : 'select_all');
                                })()}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  const selectableItemIds = folio.items
                                    .filter(item => item?.folio?.invoiced !== true && item?.on_invoice !== true)
                                    .map(item => item.id);
                                  const draggedItemIdSet = new Set(draggedItems.map(itemId => String(itemId)));
                                  const selectableItemIdSet = new Set(selectableItemIds.map(id => String(id)));
                                  const isAllSelected = selectableItemIds.length > 0
                                    && selectableItemIds.every(id => draggedItemIdSet.has(String(id)));

                                  if (isAllSelected) {
                                    const remainingDraggedItems = draggedItems
                                      .filter(id => !selectableItemIdSet.has(String(id)));
                                    setDraggedItems(remainingDraggedItems);
                                    if (remainingDraggedItems.length < 1) {
                                      setDraggedItemFolio(null);
                                    }
                                    return;
                                  }

                                  setDraggedItemFolio(folio?.folio?.id);
                                  setDraggedItems(selectableItemIds);
                                }}/>
                      }
                    </div>
                  </div>
                </div>
              )
            })}
            {receipt && window.App.urlVars().invoiceId &&
              <div
                style={{minWidth: '300px', maxWidth: '33%'}}
                className="p-col receipt"
                onDragOver={handleDragOver}
                onDrop={(e) => {
                  setLoading(true)
                  if (draggedItems && !draggedItems[0] && draggedItem && draggedItem.id) {
                    apiCall('post', 'invoice-item', {
                      folio_item: draggedItem.id,
                      invoice: receipt.id,
                      name: draggedItem.service?.name,
                      quantity: draggedItem.quantity,
                      unit: draggedItem.unit,
                      unit_net_amount: Math.round(draggedItem.unit_net_amount),
                      vat_percent: draggedItem.vat_percent,
                    })
                      .then(response => {
                        apiCall('get', 'invoice/' + response.data.data.invoice.id)
                          .then(response => {
                            setReceipt(response.data.data)
                            setDraggedItem(null)
                            window.App.toastShow('success', t('success'), t('item_added_to_invoice'), '', response);
                            window.App.setState({rerenderFolioDnd: Math.random()})
                            setLoading(false)
                            const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
                              + Cookies.get("instanceId") + "/invoice/" + receipt.id;
                            const eventSource = openMercureSubscription({
                              topics: [topic],
                            });
                            if (!eventSource) {
                              return;
                            }
                            console.log('feliratkozás történt: ' + topic);
                            eventSource.onmessage = (event) => {
                              const data = JSON.parse(event.data);
                              console.log('push notification arrived:');
                              console.log(data)
                              window.App.setState({rerenderFolioDnd: Math.random()})
                              setLoadingPrices(false)
                              closeMercureSubscription(eventSource);
                            }
                          })
                          .catch(error => {
                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                          })
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        setLoading(false)
                      })
                  } else {
                    window.App.customToastShow('warn', t('warning'), 'Jelenleg csak egy elem adható egyszerre a számlához.');
                    setDraggedItems([])
                    setLoading(false)
                  }
                }}
              >
                <div className="column-header p-mb-2 dropzone" style={{borderRadius: "4px"}}>
                  <h4 className={"p-p-0 p-m-0"}>{t('receipt')} {window.App.urlVars().invoiceId}</h4>
                  <span className={"p-d-block"}>
                    {receipt?.buyer_name}
                  </span>
                  <div className={"p-grid p-mt-1"}>
                    <div className={"p-col-7 p-py-0 p-col-align-center"}>
                      <small className={"p-d-block"}>
                        {t('net_amount')}:
                        &nbsp;
                        <span className={""}>
                              {currencyFormatter.format(
                                receipt.net_amount, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                }
                              )} {receipt.currency}
                            </span>
                      </small>
                      <small className={"p-d-block"}>
                        {t('gross_amount')}:
                        &nbsp;
                        <span className={""}>
                              {currencyFormatter.format(
                                receipt.gross_amount, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                }
                              )} {receipt.currency}
                            </span>
                      </small>
                    </div>
                  </div>
                </div>
                {receipt.items && receipt.items[0] &&
                  receipt.items.map((item) => {
                    return (
                      <Card
                        id={'receipt-item' + item.id}
                        className="grid-cell p-my-3">
                        <div className="p-grid">
                          <div className="p-col-6 p-py-0">
                            <span className="p-d-block p-text-bold">
                              {item.name}
                            </span>
                            <div>
                              {formatQuantity(item.quantity)} {item?.unit}
                            </div>
                          </div>
                          <div className="p-col-6 p-py-0 p-text-bold p-text-right">
                            <label htmlFor="tot_price" className={"p-d-block"}>
                              {t('tot_price')}
                              {/*&nbsp;*/}
                              {/*<i className={"pi pi-info-circle"} style={{cursor: 'pointer'}} onClick={() => {*/}
                              {/*  document.getElementById('price-' + item.id).classList.toggle("p-d-none");*/}
                              {/*}}></i>*/}
                            </label>
                            {currencyFormatter.format(
                              item.gross_amount, {
                                precision: t('currency_precision'),
                                symbol: t('currency_symbol'),
                                decimal: t('currency_decimal'),
                                thousand: t('currency_thousand'),
                              }
                            )}
                            &nbsp; {item?.currency}
                          </div>
                        </div>
                      </Card>
                    )
                  })
                }
              </div>
            }
          </div>
          <Dialog header={t('add_note')} visible={dialog}
                  footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}}
                                                   severity="info" text={t("dialog_movable")}/></React.Fragment>}
                  onHide={() => {
                    setDialog(false)
                  }} modal={false}>
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-12"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="note">{t('note')}</label>
                    <span className="p-d-block">
                        <InputText id="note"
                                   onChange={(e) => {
                                     setNote(e.target.value)
                                   }}
                                   value={note}
                        />
                    </span>
                  </div>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col"}>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                          label={t('save')}
                          loading={loading}
                          onClick={() => {
                            setLoading(true)
                            apiCall('patch', "folio-item/" + draggedItem.id, {folio: targetFolioId, note: note})
                              .then(response => {
                                setLoadingFolios([targetFolioId, sourceFolioId])
                                setLoadingPrices(true)
                                setDraggedItem(null);
                                setSourceFolioId(null);
                                setTargetFolioId(null);
                                setNote('')
                                setDialog(false)
                                window.App.setState({
                                  rerenderFolioDnd: Math.random(),
                                  rerenderFolioList: Math.random(),
                                })
                              })
                              .catch(error => {
                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                              })
                          }}
                          className="p-button-success p-ml-2"/>
                </div>
              </div>
            </Panel>
          </Dialog>
        </Panel>
      }
    </>
  )
}
export default withTranslation('common')(_FM_FolioDndComponent);
